export default __webpack_public_path__ + "static/media/Aula4.7ce66603.jpeg";